import { render, staticRenderFns } from "./WebComponentWrapper.vue?vue&type=template&id=7a4a576a&scoped=true&shadow"
import script from "./WebComponentWrapper.vue?vue&type=script&lang=ts&shadow"
export * from "./WebComponentWrapper.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./WebComponentWrapper.vue?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./WebComponentWrapper.vue?vue&type=style&index=1&id=7a4a576a&scoped=true&lang=css&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7a4a576a",
  null
  ,true
)

export default component.exports